import React, { useEffect, useState } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router";
import { getDoctorDetailAPI } from "../../api/doctor";
import { toast } from "react-toastify";
import { BASE_URL_IMG } from "../../assets/constants";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import {
  Block,
  BlockBetween,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  OverlineTitle,
  Row,
  Sidebar,
  TooltipComponent,
  UserAvatar,
} from "../../components/Component";
import { Badge, Card } from "reactstrap";
import { findUpper, getSmartInitials } from "../../utils/Utils";
import useLogout from "../../hooks/useLogout";

const DoctorDetail = () => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    setError,
    clearErrors,
    reset,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      isLoading: false,
      debounceLoading: false,

      stateList: [],
      cityList: [],
      specializationDD: [],

      profile_image: null,
      profile_img: null,

      pan_image: null,
      pan_img: null,

      cert_image: null,
      cert_img: null,

      aadhaar_f_image: null,
      aadhaar_f_img: null,

      aadhaar_b_image: null,
      aadhaar_b_img: null,
      qualifications: [
        {
          degree: "",
          passing_year: "",
          certificate_no: "",
          university: "",
          certificate: null,
          certificate_url: null,
          referral_code: null,
        },
      ],
    },
  });
  const logout = useLogout();
  const { fields, append, remove } = useFieldArray({
    control,
    name: "qualifications",
  });
  const location = useLocation();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("personal");
  const [sideBar, setSidebar] = useState(false);
  // function to toggle sidebar
  const toggle = () => {
    setSidebar(!sideBar);
  };
  useEffect(() => {
    sideBar ? document.body.classList.add("toggle-shown") : document.body.classList.remove("toggle-shown");
  }, [sideBar]);
  console.log("location", location);
  useEffect(() => {
    const body = {
      id: location?.state?.doctor_id,
    };
    getDrDetails(body);
  }, []);
  const getDrDetails = (body) => {
    getDoctorDetailAPI(body)
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          toast.clearWaitingQueue();
          setValue("doctorDetail", res.data.data);
          const doctor = res.data.data;
          setValue("isLoading", false);
          setValue("bio", doctor?.about);
          setValue("referral_code", doctor?.refferal_code || null);
          setValue("name", doctor?.name || null);
          setValue("email", doctor?.email || null);
          setValue("mobile", doctor?.mobile || null);
          setValue("alt_mobile", doctor?.phone_consult || null);
          setValue("experience", doctor?.experience || null);
          setValue("registration", doctor?.registration_no || null);
          const gen = [
            { value: "male", label: "Male" },
            { value: "female", label: "Female" },
            { value: "other", label: "Other" },
          ].find((item) => item.value == doctor?.gender);
          setValue("gender", gen || null);
          setValue("state", doctor?.state || null);
          setValue("city", doctor?.city || null);
          setValue("pin_code", doctor?.pin_code || null);
          setValue("specialization", doctor?.specialization || null);
          if (doctor?.known_language) {
            const tagArray = doctor?.known_language?.map((tag) => {
              const trimmed = tag.trim();
              return {
                label: trimmed,
                value: trimmed,
              };
            });

            setValue("known_language", tagArray);
          }
          setValue("address", doctor?.address || null);
          setValue("aadhaar_f_image", BASE_URL_IMG + doctor?.addhar_front_image || null);
          setValue("aadhaar_b_image", BASE_URL_IMG + doctor?.addhar_back_image || null);
          setValue("profile_image", BASE_URL_IMG + doctor?.profile_image || null);
          setValue("pan_image", BASE_URL_IMG + doctor?.pan_no || null);
          setValue("cert_image", BASE_URL_IMG + doctor?.cert_image || null);
          setValue("dob", new Date(doctor?.dob || null));
          setValue("year_of_completion", new Date(doctor?.year_of_completion || null));
          doctor?.qualification_data?.forEach((item, index) => {
            // Ensure enough fields exist
            if (index > 0) {
              append({
                degree: "",
                passing_year: "",
                certificate_no: "",
                university: "",
                certificate: null,
                certificate_url: null,
                referral_code: null,
              });
            }
            setValue(`qualifications[${index}].degree`, item.degree);
            setValue(`qualifications[${index}].passing_year`, new Date(item.passing_year));
            setValue(`qualifications[${index}].university`, item.university);
            setValue(`qualifications[${index}].certificate_no`, item.certificate_no);
            setValue(`qualifications[${index}].certificate`, BASE_URL_IMG + item.certificate || "");
            setValue(`qualifications[${index}].certificate_url`, BASE_URL_IMG + item.certificate || "");
            if (item.certificate_type) {
              setValue(`qualifications[${index}].certificate_type`, item.certificate_type);
            }
          });

          const avail = [
            { value: "Monthly", label: "Monthly" },
            { value: "Weekdays", label: "Weekdays" },
            { value: "Weekends", label: "Weekends" },
          ].find((item) => item.value == doctor?.availability);
          setValue("show_availability", avail || null);
          setValue("online_consultation_fees", doctor?.online_consultation_fees || null);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          setValue("doctorDetail", []);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };
  const doctor = watch("doctorDetail");
  console.log("dttt", doctor);

  const handleSlotManagement = (row) => {
    console.log("slot", row, doctor);
    setActiveTab("slots");
    navigate("/doctor/slot-management", { state: { data: doctor } });
  };
  return (
    <>
      <Head title={"Doctor Detail"} />
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle tag="h3" page>
                Doctor / <strong className="text-primary small">{doctor?.name || ""}</strong>
              </BlockTitle>
              <BlockDes className="text-soft">
                <ul className="list-inline">
                  <li>
                    User ID: <span className="text-base">UD003054</span>
                  </li>
                  <li>
                    Last Login: <span className="text-base">{doctor?.lastLogin || ""} 01:02 PM</span>
                  </li>
                </ul>
              </BlockDes>
            </BlockHeadContent>
            <BlockHeadContent>
              <Button color="primary" outline className={`  me-n1`} onClick={() => navigate(-1)}>
                <Icon name="arrow-left"></Icon>
                <span>Back</span>
              </Button>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          <Card>
            <div className="card-aside-wrap" id="user-detail-block">
              <div className="card-content">
                <ul className="nav nav-tabs nav-tabs-mb-icon nav-tabs-card">
                  <li className="nav-item">
                    <a
                      className={`nav-link  ${activeTab == "personal" ? "active" : ""}`}
                      href="#personal"
                      onClick={(ev) => {
                        ev.preventDefault();
                        setActiveTab("personal");
                      }}
                    >
                      <Icon name="user-circle"></Icon>
                      <span>Personal</span>
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className={`nav-link  ${activeTab == "qualification" ? "active" : ""}`}
                      href="#qualification"
                      onClick={(ev) => {
                        ev.preventDefault();
                        setActiveTab("qualification");
                      }}
                    >
                      <Icon name="award"></Icon>
                      <span>Qualification</span>
                    </a>
                  </li>
                  {/* <li className="nav-item">
                    <a
                      className={`nav-link  ${activeTab == "documents" ? "active" : ""}`}
                      href="#documents"
                      onClick={(ev) => {
                        ev.preventDefault();
                        setActiveTab("documents");
                      }}
                    >
                      <Icon name="file-text"></Icon>
                      <span>Documents</span>
                    </a>
                  </li> */}
                  <li className="nav-item">
                    <a
                      className={`nav-link  ${activeTab == "experience" ? "active" : ""}`}
                      href="#experience"
                      onClick={(ev) => {
                        ev.preventDefault();
                        setActiveTab("experience");
                      }}
                    >
                      <Icon name="file-text"></Icon>
                      <span>Experience</span>
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className={`nav-link  ${activeTab == "slots" ? "active" : ""}`}
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        handleSlotManagement(doctor);
                      }}
                    >
                      <Icon name="file-text"></Icon>
                      <span>Slots</span>
                    </a>
                  </li>

                  {/* <li className="nav-item nav-item-trigger d-xxl-none">
                                              <Button className={`toggle btn-icon btn-trigger ${sideBar && "active"}`} onClick={toggle}>
                                                <Icon name="user-list-fill"></Icon>
                                              </Button>
                                            </li> */}
                </ul>
                <div className="card-inner">
                  {activeTab == "personal" && (
                    <>
                      <Block>
                        <BlockHead>
                          <BlockTitle tag="h5">Personal Information</BlockTitle>
                        </BlockHead>
                        <div className="profile-ud-list">
                          <div className="profile-ud-item">
                            <div className="profile-ud wider">
                              <span className="profile-ud-label">Title</span>
                              <span className="profile-ud-value">Dr.</span>
                            </div>
                          </div>
                          <div className="profile-ud-item">
                            <div className="profile-ud wider">
                              <span className="profile-ud-label">Full Name</span>
                              <span className="profile-ud-value">{doctor?.name}</span>
                            </div>
                          </div>
                          <div className="profile-ud-item">
                            <div className="profile-ud wider">
                              <span className="profile-ud-label">Date of Birth</span>
                              <span className="profile-ud-value">{doctor?.dob}</span>
                            </div>
                          </div>
                          <div className="profile-ud-item">
                            <div className="profile-ud wider">
                              <span className="profile-ud-label">Surname</span>
                              <span className="profile-ud-value">{doctor?.name?.split(" ")[1]}</span>
                            </div>
                          </div>
                          <div className="profile-ud-item">
                            <div className="profile-ud wider">
                              <span className="profile-ud-label">Mobile Number</span>
                              <span className="profile-ud-value">{doctor?.phone}</span>
                            </div>
                          </div>
                          <div className="profile-ud-item">
                            <div className="profile-ud wider">
                              <span className="profile-ud-label">Email Address</span>
                              <span className="profile-ud-value">{doctor?.email}</span>
                            </div>
                          </div>
                        </div>
                      </Block>

                      <div className="nk-divider divider md"></div>
                    </>
                  )}
                  {activeTab == "qualification" && (
                    <Block>
                      <BlockHead>
                        {/* <BlockTitle tag="h5">Personal Qualification</BlockTitle> */}
                        <table className="table">
                          <thead>
                            <tr>
                              <th scope="col">#</th>
                              <th scope="col">Degree</th>
                              <th scope="col">University</th>
                              <th scope="col">Passing Year</th>
                            </tr>
                          </thead>
                          <tbody>
                           { doctor?.qualification_data?.map((item,index)=>(
                            <tr>
                              <th scope="row">{index+1}</th>
                              <td>{item?.degree||""}</td>
                              <td>{item?.university||""}</td>
                              <td>{item?.passing_year}</td>
                            </tr>
                           ))}
                           
                          </tbody>
                        </table>
                      </BlockHead>
                    </Block>
                  )}
                  {activeTab == "experience" && (
                    <Block>
                      <BlockHead>
                        {/* <BlockTitle tag="h5">Experience</BlockTitle> */}
                         <table className="table">
                          <thead>
                            <tr>
                              <th scope="col">#</th>
                              <th scope="col">Organization</th>
                              <th scope="col">Department</th>
                              <th scope="col">Start</th>
                              <th scope="col">End</th>
                            </tr>
                          </thead>
                          <tbody>
                           { doctor?.experience_data?.map((item,index)=>(
                            <tr>
                              <th scope="row">{index+1}</th>
                              <td>{item?.organization||""}</td>
                              <td>{item?.department?.label||""}</td>
                              <td>{item?.from_date}</td>
                              <td>{ item?.is_current ? "Present": item?.to_date}</td>
                            </tr>
                           ))}
                           
                          </tbody>
                        </table>
                      </BlockHead>
                    </Block>
                  )}
                  {activeTab == "documents" && (
                    <Block>
                      <BlockHead>
                        <BlockTitle tag="h5">Personal Documents</BlockTitle>
                      </BlockHead>
                    </Block>
                  )}
                  {activeTab == "slots" && (
                    <Block>
                      <BlockHead>
                        <BlockTitle tag="h5">Slots</BlockTitle>
                      </BlockHead>
                    </Block>
                  )}
                </div>
              </div>

              <Sidebar toggleState={sideBar}>
                <div className="card-inner">
                  <div className="user-card user-card-s2 mt-5 mt-xxl-0">
                    <UserAvatar className="lg" theme="primary" text={getSmartInitials(doctor?.name)} />
                    <div className="user-info">
                      <Badge color="outline-light" pill className="ucap">
                        {doctor?.role || "Doctor"}
                      </Badge>
                      <h5>
                        {"Dr. "}
                        {doctor?.name}
                      </h5>
                      <span className="sub-text">{doctor?.email}</span>
                    </div>
                  </div>
                </div>
                <div className="card-inner card-inner-sm">
                  <ul className="btn-toolbar justify-center gx-1">
                    <li>
                      {/* <Button
                        href="#star"
                        onClick={(ev) => {
                          ev.preventDefault();
                        }}
                        className="btn-trigger btn-icon"
                      >
                        <Icon
                          name={doctor?.is_feature == true || doctor?.is_feature == "true" ? "star-fill" : "star"}
                        ></Icon>
                      </Button> */}
                      <Button
                        href="#star"
                        onClick={(ev) => {
                          ev.preventDefault();
                        }}
                        className={`btn-trigger btn-icon ${doctor?.is_feature ? "text-primary" : ""}`}
                        id={`feature-doctor`}
                      >
                        <Icon name={doctor?.is_feature ? "star-fill" : "star"}></Icon>
                      </Button>
                      <TooltipComponent
                        iconClass="card-hint"
                        direction="top"
                        id={`feature-doctor`}
                        text={`This doctor is ${doctor?.is_feature ? "in featured" : "not in featured"} list.`}
                      />
                    </li>
                    {/* <li>
                      <Button
                        href="#download"
                        onClick={(ev) => {
                          ev.preventDefault();
                        }}
                        className="btn-trigger btn-icon"
                      >
                        <Icon name="download-cloud"></Icon>
                      </Button>
                    </li>

                    <li>
                      <Button
                        href="#cancel"
                        onClick={(ev) => {
                          ev.preventDefault();
                        }}
                        className="btn-trigger btn-icon text-danger"
                      >
                        <Icon name="na"></Icon>
                      </Button>
                    </li> */}
                  </ul>
                </div>
                {/* <div className="card-inner">
                  <div className="overline-title-alt mb-2">In Account</div>
                  <div className="profile-balance">
                    <div className="profile-balance-group gx-4">
                      <div className="profile-balance-sub">
                        <div className="profile-balance-amount">
                          <div className="number">
                            2,500.00 <small className="currency currency-usd">INR</small>
                          </div>
                        </div>
                        <div className="profile-balance-subtitle">Referral Amount</div>
                      </div>
                      <div className="profile-balance-sub">
                        <span className="profile-balance-plus text-soft">
                          <Icon className="ni-plus"></Icon>
                        </span>
                        <div className="profile-balance-amount">
                          <div className="number">1,643.76</div>
                        </div>
                        <div className="profile-balance-subtitle">Profit Earned</div>
                      </div>
                    </div>
                  </div>
                </div> */}
                {/* <div className="card-inner">
                  <Row className="text-center">
                    <Col size="4">
                      <div className="profile-stats">
                        <span className="amount">{doctor?.tasks || 0}</span>
                        <span className="sub-text">Appointment</span>
                      </div>
                    </Col>
                    <Col size="4">
                      <div className="profile-stats">
                        <span className="amount">{doctor?.projects || 0}</span>
                        <span className="sub-text">Complete</span>
                      </div>
                    </Col>
                    <Col size="4">
                      <div className="profile-stats">
                        <span className="amount">{doctor?.performed || 0}</span>
                        <span className="sub-text">Pending</span>
                      </div>
                    </Col>
                  </Row>
                </div> */}
                <div className="card-inner">
                  <OverlineTitle tag="h6" className="mb-3">
                    Specialization
                  </OverlineTitle>
                  <ul className="g-1">
                    {doctor?.specialization?.map((item, index) => (
                      <li className="btn-group">
                        <Button
                          color="light"
                          size="xs"
                          className="btn-dim"
                          onClick={(ev) => {
                            ev.preventDefault();
                          }}
                        >
                          {item?.label}
                        </Button>
                        <Button
                          color="light"
                          size="xs"
                          className="btn-icon btn-dim"
                          onClick={(ev) => {
                            ev.preventDefault();
                          }}
                        >
                          {/* <Icon className="ni-cross"></Icon> */}
                        </Button>
                      </li>
                    ))}
                  </ul>
                </div>
              </Sidebar>
            </div>
          </Card>
        </Block>
      </Content>
    </>
  );
};

export default DoctorDetail;
